import {
  OnInit,
  Component,
  ElementRef,
  ViewChild,
  Inject,
  Optional,
  NgZone
} from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { GoogleAddressSearchComponent } from '../google-address-search/google-address-search.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'ngx-select-last-stop',
  templateUrl: './select-last-stop.component.html',
  styleUrls: ['./select-last-stop.component.scss']
})
export class SelectLastStopComponent implements OnInit {
  addresstext: string;
  latitude: number;
  longitude: number;
  zoom: number;
  shouldShow: boolean;
  private geoCoder;
  @ViewChild('search', { static: true }) searchElementRef: ElementRef;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private apiprovider: ApiProvider,
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<GoogleAddressSearchComponent>,
    private toastservice: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.shouldShow = false;
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();

      this.searchElementRef.nativeElement.click();

      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['address'],
          componentRestrictions: { country: 'ca' }
        }
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }

  public markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }

  public getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.addresstext = results[0].formatted_address;

            this.ngZone.run(() => {
              // set latitude, longitude and zoom
              this.latitude = results[0].geometry.location.lat();
              this.longitude = results[0].geometry.location.lng();
            });
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public save(): void {

    this.shouldShow = true;
    // Call the endpoint
    this.toastservice.success(
      'Changement addresse',
      'Changement addresse effectué',
      {
        positionClass: 'toast-bottom-left',
        disableTimeOut: false,
        enableHtml: true
      }
    );
    this.dialogRef.close(false);
  }
}
